import { useTranslation } from "react-i18next";
import { colors } from "../../../data/colors";
import convertDate from "../../../utils/convertDate";
import { toPrice } from "../../../utils/toPrice";
import { stdObject } from "../../../data/types/stdObject";
import RecordIssues from "./RecordIssues";
import { issueSeparatorCode } from "../../../data/types/issues";
import { useDocContext } from "../../../context/MainContext";
import { docItemCodes } from "../../../data/docCodes";
import BasicInput from "../../BasicInput";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import { sortGroup } from "../../../utils/sortGroup";

export default function RecordIssuesCard({ data, index }: stdObject) {
  const { t } = useTranslation();
  const userAccess: stdObject = useSelector(
    (state: RootState) => state.data.userAccess,
  );
  const { recordFields, changeRecActive, headerInfo } = useDocContext();
  const mainInfo = [
    { code: "AGE", label: "c.AGE", value: data.ANOSEV },
    { code: "INT", label: "c.INT", value: data.INTNSEV },
    { code: "PRE", label: "d.PRE", value: toPrice(data.PRESEV) },
  ];
  return (
    <div className="issuesCard">
      <div className="issuesCardHeader">
        <div
          style={{
            position: "relative",
            fontSize: 14,
            fontWeight: "bolder",
            display: "flex",
            flexDirection: "row",
          }}
        >
          {userAccess.C.C1R >= 2 && !headerInfo.length && (
            <BasicInput
              type={"checkbox"}
              style={{
                position: "absolute",
                width: "auto",
                right: 0,
                top: 0,
                transform: "scale(1.5)",
              }}
              value={data.active ? "1" : "0"}
              onChange={(v: any) => changeRecActive(index, v.target.value)}
            />
          )}
          {t("c.SEV")} {data.SERSEV}-{data.CODSEV}
        </div>
        <div>
          {t("c.FEC")}: {convertDate({ info: data.FECSEV, t })}
        </div>
      </div>
      <div>
        <div style={{ padding: 5 }}>
          {mainInfo
            .filter((e: stdObject) => recordFields[e.code])
            .map((e: stdObject, idx: number) => (
              <div key={idx}>
                {t(e.label)}: {e.value}
              </div>
            ))}
        </div>
        {!!recordFields.SDA &&
          sortGroup(
            data.issues.filter(
              (v: stdObject) => v.TIPSDD !== issueSeparatorCode,
            ),
            "GRUSDD",
            "ORDSDD",
          ).map((v: stdObject, idx: number) => (
            <RecordIssues key={idx} data={v} mainWidth={true} blocked={true} />
          ))}
        {!!recordFields.ART && data.items.length > 0 && (
          <table cellSpacing={0} cellPadding={3} style={{ width: "100%" }}>
            <tbody>
              <tr>
                <td
                  colSpan={
                    docItemCodes.filter((o: string) => recordFields[o]).length
                  }
                  style={{ backgroundColor: colors.grey, textAlign: "center" }}
                >
                  {t("p.items")}
                </td>
              </tr>
              {data.items.map((v: stdObject, idx: number) => (
                <tr
                  key={idx}
                  style={{
                    backgroundColor:
                      idx % 2 === 0 ? colors.lightGrey : colors.white,
                  }}
                >
                  {docItemCodes
                    .filter((o: string) => recordFields[o])
                    .map((o: string, index: number) => (
                      <td
                        key={index}
                        align={
                          ["ARTSE0", "NOMSE0"].includes(o) ? "left" : "right"
                        }
                      >
                        {["PRESE0", "TOTSE0"].includes(o)
                          ? toPrice(v[o])
                          : o === "CANSE0"
                            ? v[o] + " X"
                            : v[o]}
                      </td>
                    ))}
                </tr>
              ))}
            </tbody>
          </table>
        )}
        <div style={{ padding: 5 }}>
          <table cellSpacing={0} cellPadding={3} style={{ width: "100%" }}>
            <tbody>
              {["NET", "IMP", "TOT"]
                .filter((e: string) => recordFields[e])
                .map((e: string, index: number) => (
                  <tr key={index}>
                    <td style={{ textAlign: "right", width: "90%" }}>
                      {t(`c.${e}`)}
                    </td>
                    <td style={{ textAlign: "right" }}>
                      {toPrice(data[`${e}SEV`])}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
